import { AxiosError } from "axios";
import LoginResponse from "../model/auth/LoginResponse";
import { api } from "../api/api";
import LoginRequest from "../model/auth/LoginRequest";
import SolicitarTrocaSenhaRequest from "../model/auth/SolicitarTrocaSenhaRequest";
import TokenData from "../model/TokenData";
import { Buffer } from 'buffer';
import TrocarSenhaRequest from "../model/auth/TrocarSenhaRequest";
import Usuario from "../model/Usuario";

class AuthService {
    logar(user: string, senha: string) {
        return new Promise<LoginResponse>((resolve, reject): void => {
            api
                .post(`/auth/login`, JSON.stringify(new LoginRequest(user, senha)))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err));
        });
    }

    solicitarTrocaSenha(email: string) {
        return new Promise<void>((resolve, reject): void => {
            let url = `/auth/solicitarTrocaSenha`;
            api
                .post(url, new SolicitarTrocaSenhaRequest(email))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    trocarSenha(token: string, password: string) {
        return new Promise<void>((resolve, reject): void => {
            let url = `/auth/trocarSenha`;
            api
                .post(url, new TrocarSenhaRequest(token, password))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getDadosUsuarioLogado() {
        return new Promise<Usuario>((resolve, reject): void => {
            let url = `/auth/usuarioLogado`;
            api
                .get(url)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getTokenData(): TokenData {
        try {

            const payload = JSON.parse(Buffer.from(localStorage.getItem('token')!.split('.')[1], 'base64').toString());
            return JSON.parse(payload.userData);
        } catch {
            return new TokenData(0, '', '');
        }
    }

}

export default AuthService;